import React from "react";
import { Puzzle } from "../lib/Game";
import GridCell from "./GridCell";

interface GameBoardProps {
  puzzle: Puzzle;
}

const GameBoard: React.FC<GameBoardProps> = ({ puzzle }) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          display: "grid",
          width: "600px",
          height: "600px",
          padding: "20px",
          border: "2px solid black",
          backgroundColor: "white",
          gridTemplateColumns: `repeat(${puzzle.cols}, 1fr)`,
          gridTemplateRows: `repeat(${puzzle.rows}, 1fr)`,
          gap: "10px",
        }}
      >
        {puzzle.cells.flat().map((cell) => (
          <GridCell key={cell.id} cell={cell} />
        ))}
      </div>
    </div>
  );
};

export default GameBoard;
